// gimme: conversations-inbox-ui 05/26/2020 741c62dc71ca742adbc6d64d61d30de7cb46539f
'use es6';

import { getSettingsBaseUrl } from './getSettingsBaseUrl';
import PortalIdParser from 'PortalIdParser';
export const getSettingsRootUrl = () => `${getSettingsBaseUrl()}/${PortalIdParser.get()}`;